// Leest een stroom server-sent events uit (de AI-interviewer en de Decca-chat).
//
// Los van de afnemers omdat dit het enige stuk is dat op een tekenreeks werkt en
// dus zonder browser te toetsen valt. Een SSE-blok kan midden in een netwerk-
// pakketje eindigen, dus wat overblijft moet bewaard worden tot de rest komt —
// knip je te vroeg, dan krijg je JSON.parse-fouten op geldige gegevens. De
// Decca-chat knipte zelf per pakketje en verloor zo stil elke bevestigingskaart
// groter dan ~8 KB (gemeten 2026-10-20: een rapportvoorstel van 19 KB).
//
// AI-CONTEXT: See docs/features/decca-live-rapport-klaarzetten.md

/**
 * @param {ReadableStream} body - De `body` van het fetch-antwoord
 * @param {(event: object) => (void|Promise<void>)} onEvent - Krijgt elke gebeurtenis
 *   los, in volgorde; geeft hij een belofte terug, dan wacht de lezer daarop vóór
 *   de volgende gebeurtenis
 * @returns {Promise<void>} Klaar zodra de server de verbinding sluit
 */
const parseSseStream = async (body, onEvent) => {
    const reader = body.getReader();
    const decoder = new TextDecoder();
    let rest = '';

    const verwerk = async (blok) => {
        for (const regel of blok.split('\n')) {
            if (!regel.startsWith('data: ')) continue;
            let event;
            try {
                event = JSON.parse(regel.slice(6));
            } catch (error) {
                // Eén onleesbaar blok mag de rest van het gesprek niet stoppen,
                // maar wel zichtbaar zijn.
                console.error('parseSseStream: onleesbare gebeurtenis overgeslagen', error);
                continue;
            }
            await onEvent(event);
        }
    };

    for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        rest += decoder.decode(value, { stream: true });
        const blokken = rest.split('\n\n');
        rest = blokken.pop() || '';
        for (const blok of blokken) await verwerk(blok);
    }
    if (rest.trim()) await verwerk(rest);
};

export default parseSseStream;
